import { Pipe, PipeTransform } from '@angular/core';

import { RunStatus } from '../runs/run-status.enum';
import { OptimisationStatus } from '../shared/enums/optimisation-status.enum';

/** How each run or optimisation status reads and looks. Infeasible is outlined so it doesn't read as a broken job. */
export const STATUS: Record<string, { label: string; cls: string; icon: string }> = {
  [RunStatus.Started]: { label: 'Started', cls: 'text-bg-secondary', icon: 'bi-play' },
  [RunStatus.Running]: { label: 'Running', cls: 'text-bg-warning', icon: 'bi-stopwatch' },
  [RunStatus.Success]: { label: 'Success', cls: 'text-bg-success', icon: 'bi-check-lg' },
  [RunStatus.Failure]: { label: 'Failure', cls: 'text-bg-danger', icon: 'bi-exclamation-circle' },
  [OptimisationStatus.Optimal]: { label: 'Optimised', cls: 'text-bg-success', icon: 'bi-check-lg' },
  [OptimisationStatus.Infeasible]: { label: 'Infeasible', cls: 'status-infeasible', icon: 'bi-slash-circle' },
};

@Pipe({
  name: 'status',
  standalone: true,
})
export class StatusPipe implements PipeTransform {
  transform(value: RunStatus | OptimisationStatus | string | undefined): string {
    return (value && STATUS[value]?.label) ?? '';
  }
}
